import React from "react";
import Orders from "../components/Orders";
import BackBtn from "../components/utilities/BackBtn";

const Chef = () => {
  return (
    <>
      <BackBtn />
      <Orders />
    </>
  );
};

export default Chef;
